import cx from 'classnames';
import { CSSProperties, forwardRef, useCallback } from 'react';

import noop from '@libs/noop';

import './CheckBox.scss';

interface CheckBoxProps {
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  isChecked?: boolean;
  isHover?: boolean;
  testId?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  (
    {
      ariaLabel,
      className,
      disabled,
      id,
      isChecked,
      isHover,
      style,
      testId,
      onClick,
    }: CheckBoxProps,
    ref
  ) => {
    const handleClick = useCallback(() => {
      if (!disabled && onClick) {
        onClick();
      }
    }, [disabled, onClick]);

    return (
      <div // eslint-disable-line
        aria-checked={isChecked}
        aria-label={ariaLabel ?? undefined}
        className={cx('CheckBox', className)}
        role="checkbox"
        style={style ?? undefined}
        tabIndex={0}
        onClick={handleClick}
      >
        <input
          checked={isChecked}
          className="CheckBox__checkbox"
          data-testid={testId}
          disabled={disabled}
          id={id ?? undefined}
          ref={ref}
          type="checkbox"
          // Form <input />에 대해 Controlled Component이지만 onChange를
          // props로 전달하지 않을 경우 warning 메세지가 발생하므로 noop을 전달합니다.
          onChange={noop}
        />
        <div className="CheckBox__custom-checkbox-check" />
        <div
          className={cx('CheckBox__custom-checkbox', {
            'CheckBox__custom-checkbox--hover': isHover,
          })}
        />
      </div>
    );
  }
);

export default CheckBox;
